import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { TooltipIcon } from '../../../components/TooltipIcon/TooltipIcon';
import type { StatsProps } from './types';

type LeadingStatsGridItemProps = StatsProps & {
  valueColor?: string;
  tooltip?: string;
};

export const LeadingStatsGridItem = ({ label, tooltip, value, valueColor, dataTest }: LeadingStatsGridItemProps) => {
  const { t } = useTranslation();

  return (
    <Grid size={4} data-test={dataTest}>
      <Stack spacing={0} sx={{ alignItems: 'center' }}>
        <Typography
          variant="caption"
          sx={{ color: 'text.secondary', height: '28px', display: 'flex', alignItems: 'center' }}
        >
          {label}
          {!!tooltip && <TooltipIcon data-test="spend-tooltip-icon" title={t(tooltip)} />}
        </Typography>

        <Typography data-test="value" variant="h3" sx={{ color: valueColor }}>
          {value}
        </Typography>
      </Stack>
    </Grid>
  );
};
